export function isOutOfRange(focusedIndex, range) {
    return focusedIndex < range.startIndex || focusedIndex > range.endIndex;
}
